import React from "react";

const Dev = () =>{
    return (
        <>
            <div className="bg-red-600 shadow-inner dev_div text-center">
                {/* <div className="text-white text-5xl">D</div>
                <div className="text-white text-5xl">E</div>
                <div className="text-white text-5xl">V</div>
                <div className="text-white text-5xl">E</div>
                <div className="text-white text-5xl">L</div>
                <div className="text-white text-5xl">O</div>
                <div className="text-white text-5xl">P</div>
                <div className="text-white text-5xl">E</div>
                <div className="text-white text-5xl">R</div> */}
            </div>
        </>
    )
}

export default Dev